var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6842 1.33333H7.57895V0.333333C7.57895 0.15 7.43684 0 7.26316 0H4.73684C4.56316 0 4.42105 0.15 4.42105 0.333333V1.33333H0.315789C0.142105 1.33333 0 1.48333 0 1.66667V9.66667C0 9.85 0.142105 10 0.315789 10H11.6842C11.8579 10 12 9.85 12 9.66667V1.66667C12 1.48333 11.8579 1.33333 11.6842 1.33333ZM5.05263 0.666667H6.94737V1.33333H5.05263V0.666667ZM11.3684 9.33333H0.631579V6H5.05263V6.98333C5.05263 7.16667 5.19474 7.31667 5.36842 7.31667H6.63158C6.80526 7.31667 6.94737 7.16667 6.94737 6.98333V6H11.3684V9.33333ZM5.68421 6.65V4.65H6.31579V6.65H5.68421ZM11.3684 5.33333H6.94737V4.33333C6.94737 4.15 6.80526 4 6.63158 4H5.36842C5.19474 4 5.05263 4.15 5.05263 4.33333V5.33333H0.631579V2H11.3684V5.33333Z",
    fill: "#575757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpIcon);
export default __webpack_public_path__ + "static/media/exp-icon.ad3d77b1c65d451eae2a239425859969.svg";
export { ForwardRef as ReactComponent };